import {
  combineTranslationBundles,
  type TranslationModule
} from '@hconnect/common/localization-loaders'
import {areaDashboardWidgetTranslations} from '@widgets/area-dashboard'
import {eventsSummaryWidgetTranslations} from '@widgets/events-summary'
import {expertSystemWidgetTranslations} from '@widgets/expert-system'
import {kpisWidgetTranslations} from '@widgets/kpis'
import {runningTimesWidgetTranslations} from '@widgets/running-times'
import {shiftTasksWidgetTranslations} from '@widgets/shift-tasks'

import {FEATURE_NAMESPACE} from '../consts'

const optimizationSpecialistDashboardTranslationModule: TranslationModule = {
  namespace: FEATURE_NAMESPACE,
  resources: {
    'en-US': () => import('./en_US.json'),
    'en-GB': () => import('./en_GB.json'),
    'de-DE': () => import('./de_DE.json'),
    'ru-RU': () => import('./ru_RU.json'),
    'it-IT': () => import('./it_IT.json'),
    'fr-FR': () => import('./fr_FR.json'),
    'cs-CZ': () => import('./cs_CZ.json'),
    'hu-HU': () => import('./hu_HU.json'),
    'nl-NL': () => import('./nl_NL.json'),
    'sv-SE': () => import('./sv_SE.json'),
    'es-ES': () => import('./es_ES.json'),
    'ro-RO': () => import('./ro_RO.json'),
    'no-NO': () => import('./no_NO.json'),
    'pl-PL': () => import('./pl_PL.json')
  }
}

const externalPackageTranslations = combineTranslationBundles([
  eventsSummaryWidgetTranslations,
  runningTimesWidgetTranslations,
  expertSystemWidgetTranslations,
  kpisWidgetTranslations,
  shiftTasksWidgetTranslations,
  areaDashboardWidgetTranslations
])

export const optimizationSpecialistDashboardFeatureTranslations = combineTranslationBundles([
  externalPackageTranslations,
  optimizationSpecialistDashboardTranslationModule
])
